var simplemaps_usmap_mapdata={
  main_settings: {
   //General settings
    width: "responsive", //'700' or 'responsive'
    background_color: "#FFFFFF",
    background_transparent: "yes",
    border_color: "#ffffff",
    popups: "off",
    state_description: "",
    state_color: "44,48,154",
    state_hover_color: "#41B646",
    state_url: "",
    border_size: 1.5,
    all_states_inactive: "no",
    all_states_zoomable: "no",
    
    //Location defaults
    location_description: "Add location markers using latitude and longitude!",
    location_color: "#2041D4",
    location_opacity: 0.8,
    location_hover_opacity: 1,
    location_url: "",
    location_size: 25,
    location_type: "square",
    location_image_source: "frog.png",
    location_border_color: "#FFFFFF",
    location_border: 2,
    location_hover_border: 2.5,
    all_locations_inactive: "no",
    all_locations_hidden: "no",
    
    //Label defaults
    label_color: "#ffffff",
    label_hover_color: "#ffffff",
    label_size: 22,
    label_font: "Poppins",
    hide_labels: "no",
    hide_eastern_labels: "no",
    manual_zoom: "no",
    back_image: "no",
    initial_back: "no",
    initial_zoom: -1,
    initial_zoom_solo: "no",
    region_opacity: 1,
    region_hover_opacity: 0.6,
    zoom_out_incrementally: "yes",
    zoom_percentage: 0.99,
    zoom_time: 0.5,
    
    //Popup settings
    popup_color: "white",
    popup_opacity: 1,
    popup_shadow: 1,
    popup_corners: 5,
    popup_font: "14px/1.5 Poppins, Arial, Helvetica, sans-serif",
    popup_nocss: "no",
    
    //Advanced settings
    div: "map",
    auto_load: "yes",
    url_new_tab: "no",
    images_directory: "/static/lib/simplemaps/map_images/",
    fade_time: 0.1,
    import_labels: "no",
    link_text: "View Website",
    state_image_url: "",
    state_image_position: "",
    location_image_url: ""
  },
  state_specific: {
      HI: {
      name: "Hawaii",
      url: "https://happyteacherpd.com/pages/hawaii"
    },
    AK: {
      name: "Alaska",
      url: "https://happyteacherpd.com/pages/alaska"
    },
    FL: {
      name: "Florida",
      url: "https://happyteacherpd.com/pages/florida"
    },
    NH: {
      name: "New Hampshire",
      url: "https://happyteacherpd.com/pages/new-hampshire"
    },
    VT: {
      name: "Vermont",
      url: "https://happyteacherpd.com/pages/vermont"
    },
    ME: {
      name: "Maine",
      url: "https://happyteacherpd.com/pages/maine"
    },
    RI: {
      name: "Rhode Island",
      url: "https://happyteacherpd.com/pages/rhode-island"
    },
    NY: {
      name: "New York",
      url: "https://happyteacherpd.com/pages/new-york-1"
    },
    PA: {
      name: "Pennsylvania",
      url: "https://happyteacherpd.com/pages/pennsylvania"
    },
    NJ: {
      name: "New Jersey",
      url: "https://happyteacherpd.com/pages/new-jersey"
    },
    DE: {
      name: "Delaware",
      url: "https://happyteacherpd.com/pages/delaware"
    },
    MD: {
      name: "Maryland",
      url: "https://happyteacherpd.com/pages/maryland"
    },
    VA: {
      name: "Virginia",
      url: "https://happyteacherpd.com/pages/virginia"
    },
    WV: {
      name: "West Virginia",
      url: "https://happyteacherpd.com/pages/west-virginia"
    },
    OH: {
      name: "Ohio",
      url: "https://happyteacherpd.com/pages/ohio"
    },
    IN: {
      name: "Indiana",
      url: "https://happyteacherpd.com/pages/indiana"
    },
    IL: {
      name: "Illinois",
      url: "https://happyteacherpd.com/pages/illinois"
    },
    CT: {
      name: "Connecticut",
      url: "https://happyteacherpd.com/pages/connecticut"
    },
    WI: {
      name: "Wisconsin",
      url: "https://happyteacherpd.com/pages/wisconsin"
    },
    NC: {
      name: "North Carolina",
      url: "https://happyteacherpd.com/pages/north-carolina"
    },
    DC: {
      name: "District of Columbia",
      color: "#dddddd"
    },
    MA: {
      name: "Massachusetts",
      url: "https://happyteacherpd.com/pages/massachusetts"
    },
    TN: {
      name: "Tennessee",
      url: "https://happyteacherpd.com/pages/tennessee"
    },
    AR: {
      name: "Arkansas",
      url: "https://happyteacherpd.com/pages/arkansas"
    },
    MO: {
      name: "Missouri",
      url: "https://happyteacherpd.com/pages/missouri"
    },
    GA: {
      name: "Georgia",
      url: "https://happyteacherpd.com/pages/georgia"
    },
    SC: {
      name: "South Carolina",
      url: "https://happyteacherpd.com/pages/south-carolina"
    },
    KY: {
      name: "Kentucky",
      url: "https://happyteacherpd.com/pages/kentucky"
    },
    AL: {
      name: "Alabama",
      url: "https://happyteacherpd.com/pages/alabama"
    },
    LA: {
      name: "Louisiana",
      url: "https://happyteacherpd.com/pages/louisiana"
    },
    MS: {
      name: "Mississippi",
      url: "https://happyteacherpd.com/pages/mississippi"
    },
    IA: {
      name: "Iowa",
      url: "https://happyteacherpd.com/pages/iowa"
    },
    MN: {
      name: "Minnesota",
      url: "https://happyteacherpd.com/pages/minnesota"
    },
    OK: {
      name: "Oklahoma",
      url: "https://happyteacherpd.com/pages/oklahoma"
    },
    TX: {
      name: "Texas",
      url: "https://happyteacherpd.com/pages/texas"
    },
    NM: {
      name: "New Mexico",
      url: "https://happyteacherpd.com/pages/new-mexico"
    },
    KS: {
      name: "Kansas",
      url: "https://happyteacherpd.com/pages/kansas"
    },
    NE: {
      name: "Nebraska",
      url: "https://happyteacherpd.com/pages/nebraska"
    },
    SD: {
      name: "South Dakota",
      url: "https://happyteacherpd.com/pages/south-dakota"
    },
    ND: {
      name: "North Dakota",
      url: "https://happyteacherpd.com/pages/north-dakota"
    },
    WY: {
      name: "Wyoming",
      url: "https://happyteacherpd.com/pages/wyoming"
    },
    MT: {
      name: "Montana",
      url: "https://happyteacherpd.com/pages/montana"
    },
    CO: {
      name: "Colorado",
      url: "https://happyteacherpd.com/pages/colorado"
    },
    UT: {
      name: "Utah",
      url: "https://happyteacherpd.com/pages/utah"
    },
    AZ: {
      name: "Arizona",
      url: "https://happyteacherpd.com/pages/arizona"
    },
    NV: {
      name: "Nevada",
      url: "https://happyteacherpd.com/pages/nevada"
    },
    OR: {
      name: "Oregon",
      url: "https://happyteacherpd.com/pages/oregon"
    },
    WA: {
      name: "Washington",
      url: "https://happyteacherpd.com/pages/washington"
    },
    CA: {
      name: "California",
      url: "https://happyteacherpd.com/pages/california"
    },
    MI: {
      name: "Michigan",
      url: "https://happyteacherpd.com/pages/michigan"
    },
    ID: {
      name: "Idaho",
      url: "https://happyteacherpd.com/pages/idaho"
    },
    GU: {
      color: "#dddddd"
    },
    VI: {
      color: "#dddddd"
    },
    PR: {
      color: "#dddddd"
    },
    MP: {
      color: "#dddddd"
    },
    AS: {
      color: "#dddddd"
    }
  },

  locations: {
    "0": {
      name: "New York City",
      lat: 40.7143528,
      lng: -74.0059731
    },
    "1": {
      name: "Anchorage",
      lat: 61.2180556,
      lng: -149.9002778
    }
  },
  labels: {
    NH: {
      parent_id: "NH",
      x: "932",
      y: "183",
      pill: "yes",
      width: 45,
      display: "all"
    },
    VT: {
      parent_id: "VT",
      x: "883",
      y: "243",
      pill: "yes",
      width: 45,
      display: "all"
    },
    RI: {
      parent_id: "RI",
      x: "932",
      y: "273",
      pill: "yes",
      width: 45,
      display: "all"
    },
    NJ: {
      parent_id: "NJ",
      x: "883",
      y: "273",
      pill: "yes",
      width: 45,
      display: "all"
    },
    DE: {
      parent_id: "DE",
      x: "883",
      y: "303",
      pill: "yes",
      width: 45,
      display: "all"
    },
    MD: {
      parent_id: "MD",
      x: "932",
      y: "303",
      pill: "yes",
      width: 45,
      display: "all"
    },
    DC: {
      parent_id: "DC",
      x: "884",
      y: "332",
      pill: "yes",
      width: 45,
      display: "all"
    },
    MA: {
      parent_id: "MA",
      x: "932",
      y: "213",
      pill: "yes",
      width: 45,
      display: "all"
    },
    CT: {
      parent_id: "CT",
      x: "932",
      y: "243",
      pill: "yes",
      width: 45,
      display: "all"
    },
    HI: {
      parent_id: "HI",
      x: 305,
      y: 565,
      pill: "yes"
    },
    AK: {
      parent_id: "AK",
      x: "113",
      y: "495"
    },
    FL: {
      parent_id: "FL",
      x: "773",
      y: "510"
    },
    ME: {
      parent_id: "ME",
      x: "893",
      y: "85"
    },
    NY: {
      parent_id: "NY",
      x: "815",
      y: "158"
    },
    PA: {
      parent_id: "PA",
      x: "786",
      y: "210"
    },
    VA: {
      parent_id: "VA",
      x: "790",
      y: "282"
    },
    WV: {
      parent_id: "WV",
      x: "744",
      y: "270"
    },
    OH: {
      parent_id: "OH",
      x: "700",
      y: "240"
    },
    IN: {
      parent_id: "IN",
      x: "650",
      y: "250"
    },
    IL: {
      parent_id: "IL",
      x: "600",
      y: "250"
    },
    WI: {
      parent_id: "WI",
      x: "575",
      y: "155"
    },
    NC: {
      parent_id: "NC",
      x: "784",
      y: "326"
    },
    TN: {
      parent_id: "TN",
      x: "655",
      y: "340"
    },
    AR: {
      parent_id: "AR",
      x: "548",
      y: "368"
    },
    MO: {
      parent_id: "MO",
      x: "548",
      y: "293"
    },
    GA: {
      parent_id: "GA",
      x: "718",
      y: "405"
    },
    SC: {
      parent_id: "SC",
      x: "760",
      y: "371"
    },
    KY: {
      parent_id: "KY",
      x: "680",
      y: "300"
    },
    AL: {
      parent_id: "AL",
      x: "655",
      y: "405"
    },
    LA: {
      parent_id: "LA",
      x: "550",
      y: "435"
    },
    MS: {
      parent_id: "MS",
      x: "600",
      y: "405"
    },
    IA: {
      parent_id: "IA",
      x: "525",
      y: "210"
    },
    MN: {
      parent_id: "MN",
      x: "506",
      y: "124"
    },
    OK: {
      parent_id: "OK",
      x: "460",
      y: "360"
    },
    TX: {
      parent_id: "TX",
      x: "425",
      y: "435"
    },
    NM: {
      parent_id: "NM",
      x: "305",
      y: "365"
    },
    KS: {
      parent_id: "KS",
      x: "445",
      y: "290"
    },
    NE: {
      parent_id: "NE",
      x: "420",
      y: "225"
    },
    SD: {
      parent_id: "SD",
      x: "413",
      y: "160"
    },
    ND: {
      parent_id: "ND",
      x: "416",
      y: "96"
    },
    WY: {
      parent_id: "WY",
      x: "300",
      y: "180"
    },
    MT: {
      parent_id: "MT",
      x: "280",
      y: "95"
    },
    CO: {
      parent_id: "CO",
      x: "320",
      y: "275"
    },
    UT: {
      parent_id: "UT",
      x: "223",
      y: "260"
    },
    AZ: {
      parent_id: "AZ",
      x: "205",
      y: "360"
    },
    NV: {
      parent_id: "NV",
      x: "140",
      y: "235"
    },
    OR: {
      parent_id: "OR",
      x: "100",
      y: "120"
    },
    WA: {
      parent_id: "WA",
      x: "130",
      y: "55"
    },
    ID: {
      parent_id: "ID",
      x: "200",
      y: "150"
    },
    CA: {
      parent_id: "CA",
      x: "79",
      y: "285"
    },
    MI: {
      parent_id: "MI",
      x: "663",
      y: "185"
    },
    PR: {
      parent_id: "PR",
      x: "620",
      y: "545"
    },
    GU: {
      parent_id: "GU",
      x: "550",
      y: "540"
    },
    VI: {
      parent_id: "VI",
      x: "680",
      y: "519"
    },
    MP: {
      parent_id: "MP",
      x: "570",
      y: "575"
    },
    AS: {
      parent_id: "AS",
      x: "665",
      y: "580"
    }
  },
  legend: {
    entries: []
  },
  regions: {}
};